import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { env, isProd } from '@/config/host';
import { ClientUtil } from '@xl/js-utils';
import ua from '@xl/user-agent';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;

// issue 处理
// https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
// https://github.com/hsingyin/hsingyin.site/issues/7#issue-586782745
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((error) => error);
};

const router = new VueRouter({
  mode: 'history',
  base:
    window.location.hostname === 'user-h5.xiaolachuxing.com' ? '/index/' : '/',
  routes,
});

// 导航守卫
router.afterEach((route) => {
  const title = route.meta.title;
  if (title) {
    document.title = title;
    // app内，设置app标题栏， 一定要延时，不然ios返回会显示加载中
    ua.parse().isInApp &&
      setTimeout(() => {
        ClientUtil.webcall({
          action: 'setTitle',
          title,
        });
      }, 0);
  }

  // 更新 PageSpy 展示标题
  if (
    window.$pageSpy &&
    typeof window.$pageSpy.updateRoomInfo === 'function' &&
    !isProd
  ) {
    window.$pageSpy.updateRoomInfo({
      title: `${route.meta?.title?.trim() || '用户H5'} (${env.toUpperCase()})`,
    });
  }
});

export default router;
